import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      style={{
        scale: 0.8
      }}
      className={cn(
        "peer data-[state=checked]:bg-success-solid data-[state=unchecked]:bg-control-off focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-[1.64rem] w-15 shrink-0 items-center rounded-full border border-transparent shadow-xs outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer transition-colors duration-300",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        style={{
          transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)'
        }}
        className={cn(
          "bg-surface-raised pointer-events-none block size-5.5 rounded-full w-9 ring-0 data-[state=checked]:translate-x-[calc(58%)] data-[state=unchecked]:translate-x-[1px] data-[state=checked]:shadow-lg"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }

